import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent {
  @Input() isHeaderMinimized = false;
  @Input() headerTranslateY = 0;
  @Input() headerOpacity = 1;
  @Input() userData: any = null;
  @Input() userFullName = "";
  @Input() shouldShowInitials = false;
  @Input() adressMessage = "";
  @Input() searchPlaceholder = "";
  @Input() unreadNotificationsCount = 0;

  @Output() profileClick = new EventEmitter<void>();
  @Output() notificationsClick = new EventEmitter<void>();
  @Output() configurationsClick = new EventEmitter<void>();
  @Output() locationClick = new EventEmitter<void>();
  @Output() searchInput = new EventEmitter<any>();

  onSearch(event: any) {
    this.searchInput.emit(event);
  }

  get hasUnreadNotifications(): boolean {
    return (this.unreadNotificationsCount ?? 0) > 0;
  }
}
